
<template>
  <section id="what" data-section="What is" data-section-fr="L’École">
    <div class="scene"></div>

    <div class="wrapper">
      <div class="row row--h-center">
        <div class="col-7 col-tabletH-6 col-tabletW-11 text--center">
          <h2 class="title anim--split ft-50" data-split="chars">
            {{$t('home.what.title')}}
          </h2>
          <div class="sub ft-30">{{$t('home.what.sub')}}</div>
          <p class="info text--medium anim--split ft-16" data-split="lines">
            {{$t('home.what.info')}}
<!--            {{$t('home.what.info[1]')}}<br>-->
<!--            {{$t('home.what.info[2]')}}<br>-->
<!--            {{$t('home.what.info[3]')}}<br>-->
          </p>
        </div>
      </div>
      <div class="row row--h-center">
        <div class="col-12 col-tabletH-10 text--right">
          <div class="tablet">
            <div class="tablet--item tablet--item--tablet">
              <img src="/images/tablet-face-fr.png" alt="tablet">
            </div>
            <div class="tablet--item tablet--item--water-back">
              <img src="/images/water-back.png" alt="water back">
            </div>
            <div class="tablet--item tablet--item--whale">
              <!-- src="/images/whale.png" -->
              <img alt="whale">
            </div>
            <div class="tablet--item tablet--item--water-front">
              <img src="/images/water-front.png" alt="wate front">
            </div>
            <div class="tablet--item tablet--item--fishes-front">
              <img src="/images/fishes-front.png" alt="fishes front">
            </div>
            <div class="tablet--item tablet--item--fishes-back">
              <img src="/images/fishes-back.png" alt="fishes back">
            </div>
            <div class="tablet--item tablet--item--shadow">
              <img src="/images/shadow.png" alt="shadow">
            </div>

            <img class="tablet__fallback anim--view" src="/images/whale-tablet-fr.png" alt="tablet fallback">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SceneWhat from '@/oceanSchool/sceneWhat.js'
import { qs } from '@/util/dom.js'

export default {
  beforeDestroy () {
    this.sceneWhat && this.sceneWhat.dispose()
    this.sceneWhat = null
  },

  methods: {
    start () {
      this.$nextTick(() => {
        const what = qs('.tablet', this.$el)
        this.sceneWhat = new SceneWhat('ipad-whale', what)

        const whaleImg = qs('.tablet--item--whale img', what)
        whaleImg.src = '/images/whale.png'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  color: #fff;
}

#what {
  padding: 100px 0 80px;
  margin-top: -240px;
  height: auto!important;
  background-color: #a0c5e1
}

body:not(.desktop) #what {
  margin-top: 0
}

#what .displacement {
  position: relative
}

.title {
  color: #fefefe;
  line-height: 100px;
  font-size: 28px;
  text-transform: uppercase;
}

.sub {
  color: #c7e7ff;
  line-height: 80px;
}

.info {
  color: #ddf0fe;
  line-height: 40px;
}
@media (max-width: 1366px){
  .info {
     width:70%;
    margin-left: 15%;
  }
}

@media (max-width: 1280px) {
  #what {
      margin-top:-200px
  }
}

@media (max-width: 1024px) {
  #what {
      margin-top:0
  }
}

@media (max-width: 768px) {
  #what {
      padding-top:70px
  }
}

#what .tablet {
  margin: 10px 0 30px;
  position: relative;
  display: inline-block;
  perspective: 1000px;
  transform-style: preserve-3d;
  transform-origin: center center;
  pointer-events: none;
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 970px;
  max-width: 100%
}

@media (max-width: 1024px) {
  #what .tablet {
      text-align:center
  }
}

#what .tablet--item {
  position: absolute;
  top: 0
}

@media (max-width: 1024px) {
  #what .tablet--item {
      display:none
  }
}

#what .tablet--item--shadow,#what .tablet--item--tablet {
  position: relative;
  opacity: 1
}

#what .tablet--item--tablet {
  transform: translateZ(-150px) rotateX(5deg) rotateY(-15deg) rotateZ(4deg);
  transform-origin: center right
}

#what .tablet--item--shadow {
  top: -10px;
  right: -70px
}

#what .tablet--item--whale {
  top: auto;
  bottom: 210px;
  right: 240px;
  transform: translateZ(30px)
}

#what .tablet--item--water-back,#what .tablet--item--water-front {
  top: 190px;
  right: 360px;
  overflow: hidden
}

#what .tablet--item--water-front {
  top: 250px;
  transform: translateZ(90px)
}

#what .tablet--item--water-back {
  transform: translateZ(-70px)
}

#what .tablet--item--fishes-back,#what .tablet--item--fishes-front {
  top: 325px;
  right: 130px
}

#what .tablet--item--fishes-front {
  transform: translateZ(85px)
}

#what .tablet--item--fishes-back {
  transform: translateZ(-20px)
}

#what .tablet__fallback {
  display: none
}

@media (max-width: 1024px) {
  #what .tablet__fallback {
      display:inline-block
  }
}
</style>
